"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importStar(require("react"));
const dayjs_1 = __importDefault(require("dayjs"));
const Shimmer_1 = __importDefault(require("src/components/design-system/shimmer/Shimmer"));
const useLatestActivity_1 = require("src/hooks/api/useLatestActivity");
const CompactActivity_1 = __importDefault(require("./CompactActivity"));
const CompactActivityWrapper = ({ id, involvements, isReadOnly, activityData }) => {
    const [queryEnabled, setQueryEnabled] = (0, react_1.useState)(false);
    const wrapperRef = (0, react_1.useRef)(null);
    const { data, isSuccess, isFetching } = (0, useLatestActivity_1.useLatestActivity)(id, {
        refetchOnMount: false,
        enabled: queryEnabled,
        ...(isReadOnly ? { initialData: { data: activityData } } : [])
    });
    (0, react_1.useEffect)(() => {
        if (isReadOnly)
            return;
        const target = wrapperRef?.current;
        if (target) {
            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 1.0
            };
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setQueryEnabled(true);
                    }
                });
            }, options);
            observer.observe(target);
            return () => {
                observer.disconnect();
            };
        }
    }, []);
    return (react_1.default.createElement("div", { className: "mt-[8px]", ref: wrapperRef }, isFetching ? (react_1.default.createElement(Shimmer_1.default, { height: 66, width: "100%" })) : (data?.data &&
        isSuccess && (react_1.default.createElement(CompactActivityDataManage, { data: data.data, id: id, involvements: involvements, isReadOnly: isReadOnly })))));
};
var EStateActivity;
(function (EStateActivity) {
    EStateActivity["commentOnly"] = "commentOnly";
    EStateActivity["progressOnly"] = "progressOnly";
    EStateActivity["commentAndProgress"] = "commentProgress";
    EStateActivity["empty"] = "empty";
})(EStateActivity || (EStateActivity = {}));
const getStateActivity = (valueDate, commentDate) => {
    if (!valueDate && !commentDate)
        return EStateActivity.empty;
    if (!valueDate)
        return EStateActivity.commentOnly;
    if (!commentDate)
        return EStateActivity.progressOnly;
    const value = (0, dayjs_1.default)(valueDate);
    const comment = (0, dayjs_1.default)(commentDate);
    const diff = Math.abs(value.diff(comment));
    if (diff < 5000)
        return EStateActivity.commentAndProgress;
    if (value > comment)
        return EStateActivity.progressOnly;
    return EStateActivity.commentOnly;
};
const getContent = (stateActivity, data) => {
    if (!data)
        return {};
    if (stateActivity == EStateActivity.empty)
        return {};
    if (stateActivity == EStateActivity.commentOnly) {
        const object = data.lastCommentOrAttachmentActivity?.object;
        return {
            actorName: data.lastCommentOrAttachmentActivity?.user.name,
            comment: data.lastCommentOrAttachmentActivity?.comment,
            attachments: object && {
                name: object.name,
                state: object.state,
                type: object.type,
                downloadUrl: object.downloadUrl
            },
            dateActivity: data.lastCommentOrAttachmentActivity?.doneAt,
            progresses: null
        };
    }
    if (stateActivity == EStateActivity.progressOnly) {
        const object = data.currentValueActivity?.object;
        return {
            actorName: data.currentValueActivity?.user.name,
            comment: data.currentValueActivity?.comment,
            attachments: null,
            dateActivity: data.currentValueActivity?.doneAt,
            progresses: object && {
                currentValue: object.currentValue,
                previousValue: object.previousValue
            }
        };
    }
    const objectAttachment = data.lastCommentOrAttachmentActivity?.object;
    const objectProgress = data.currentValueActivity?.object;
    return {
        actorName: data.lastCommentOrAttachmentActivity?.user.name,
        comment: data.lastCommentOrAttachmentActivity?.comment,
        attachments: objectAttachment && {
            name: objectAttachment.name,
            state: objectAttachment.state,
            type: objectAttachment.type,
            downloadUrl: objectAttachment.downloadUrl
        },
        dateActivity: data.lastCommentOrAttachmentActivity?.doneAt,
        progresses: objectProgress && {
            currentValue: objectProgress.currentValue,
            previousValue: objectProgress.previousValue
        }
    };
};
const CompactActivityDataManage = ({ data, involvements, id, isReadOnly }) => {
    const dateCurrentValue = data.currentValueActivity?.doneAt;
    const dateComment = data.lastCommentOrAttachmentActivity?.doneAt;
    const stateActivity = getStateActivity(dateCurrentValue, dateComment);
    const { actorName, comment, attachments, progresses, dateActivity } = getContent(stateActivity, data);
    return (react_1.default.createElement(CompactActivity_1.default, { actorName: actorName, comment: comment, attachments: attachments, progresses: progresses || undefined, dateActivity: dateActivity, involvements: involvements, id: id, isEmpty: stateActivity == EStateActivity.empty, isReadOnly: isReadOnly }));
};
exports.default = CompactActivityWrapper;
